export const sex = ["MALE", "FEMALE"];

export const idTypes = ["NRC", "PASSPORT", "DRIVERS_LICENSE"];

export const sc = {
	lg: 1024,
	md: 768,
	sm: 640,
	xs: 480,
};

export const getScreenSize = () => {
    return window.screen.width;
}

export const deepCopy = (src) => {
	// Handle primitives and functions (functions are copied by reference, which is the only way)
	if (src === null || typeof src !== "object") {
		return src;
	}

	// Handle arrays or objects
	const target = Array.isArray(src) ? [] : {};

	for (const key in src) {
		if (Object.prototype.hasOwnProperty.call(src, key)) {
			// Recursively deep copy nested objects/arrays
			target[key] = deepCopy(src[key]);
		}
	}

	return target;
};

export const formatDate = (date,short = false,time = false) => {
	if(!date) return "";
	if(date instanceof Date) {
		return short && time?date.toISOString().slice(0, 16):short?date.toISOString().slice(0, 10):date.toLocaleString("default", {month: "long",}) +" " + date.getDate() + ", " + date.getFullYear() + " " + date.toLocaleTimeString("en-US");
	} else if(typeof(date) === "string") {
		date = new Date(date);
		return formatDate(date,short,time);
	} else {
		return ""
	}
};


